"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gerenciatdFormskeleton = _interopRequireDefault(require("@bit/gerenciatd.formskeleton.input"));
var _gerenciatdFormskeleton2 = _interopRequireDefault(require("@bit/gerenciatd.formskeleton.select"));
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));
var _gerenciatdUnifiedcomponents2 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.button"));
var _gerenciatdUtils = require("@bit/gerenciatd.utils.js-utils");
var _gerenciatdUnifiedcomponents3 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));
var _provincias = _interopRequireDefault(require("./provincias.json"));
var _functionsUtils = require("../functionsUtils.js");
var _index = require("../index");
require("./AtencionFormulario.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // import Input from '../../../formSkeleton/Input';
// import Select from '../../../formSkeleton/Select';
const {
  IDENTIFICATION_DOCUMENT_TYPES,
  validatorList
} = _gerenciatdUtils.validators;
const ENCAMINAMIENTO_FONDOS = [_functionsUtils.TIPOS_ENCAMINAMIENTO.FONINS_A, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONINS_B, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONINS_C, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONINS_D, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONINS_E, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONGEV_A, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONGEV_B, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONGEV_C, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONGEV_D, _functionsUtils.TIPOS_ENCAMINAMIENTO.FONGEV_E];
const COMPONENT_NAME = 'AtencionFormulario';
const TextoSubTitle = {
  llamada: 'Déjanos tus datos y un experto contactará contigo para resolver dudas o ayudarte con lo que necesites. Si ya eres cliente te llamará tu comercial.',
  visita: 'Déjanos tus datos y un experto contactará contigo para concertar una visita a tu empresa o una videollamada. Si ya eres cliente lo hará tu comercial.'
};
function usePrevious(value, validateForm) {
  const ref = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    if (validateForm) {
      ref.current = value;
    }
  }, [value, validateForm]);
  return ref.current;
}
const AtencionFormulario = _ref => {
  let {
    formSkeletonProps,
    taggingInfo,
    tabOption,
    setDatos,
    datos,
    iframeReady,
    config,
    datosUsuario,
    SvgIconLoader,
    visitaDobleColumn,
    setWaiting
  } = _ref;
  const {
    submitTries,
    validateForm
  } = formSkeletonProps;
  const prevSubmitTries = usePrevious(submitTries, validateForm);
  const [PrivacyPolicy, setPrivacyPolicy] = (0, _react.useState)(false);
  if (!taggingInfo.componentName) {
    taggingInfo.componentName = COMPONENT_NAME;
  }

  /**
   * Handler de los inputs que guarda el valor en la variable de datos
   * @param {*} event Información que llega desde el onchange
   * @returns {undefined}
   */
  const handleInputChange = event => {
    setDatos(_objectSpread(_objectSpread({}, datos), {}, {
      [event.target.name]: event.target.value
    }));
  };

  /**
   * Handler del select date que guarda el valor en la variable de datos
   * @param {*} value Información que llega desde el onchange
   * @returns {undefined}
   */
  const handleSelectChangeProv = value => {
    setDatos(_objectSpread(_objectSpread({}, datos), {}, {
      provincia: value
    }));
  };
  const handleSelectChangeEmpleados = value => {
    setDatos(_objectSpread(_objectSpread({}, datos), {}, {
      numeroEmpleados: value
    }));
  };
  const envioFormulario = datos => {
    document.getElementById('iframeInsideModal').contentWindow.postMessage(datos, '*');
    // console.log(datos);
    setWaiting(true);
  };

  /**
   * Cambia entre visualizacion y ocultacion de politica de privacidad
   */
  const _togglePrivacyPolicy = () => {
    setPrivacyPolicy(!PrivacyPolicy);
  };
  const buttonPropsSize = {
    w: _gerenciatdUnifiedcomponents2.BUTTON_WIDTH.LIQUID_DOPPED,
    h: _gerenciatdUnifiedcomponents2.BUTTON_HEIGHT.LARGE
  };
  (0, _react.useEffect)(() => {
    if (!config.empleados) {
      handleSelectChangeEmpleados('No aplica');
    }
    if (!config.email) {
      setDatos(_objectSpread(_objectSpread({}, datos), {}, {
        email: 'no.aplica@noaplica.com'
      }));
    }
  }, [config]);

  /**
   * Se activa cuando el formulario es validado, o se ha intentando subir el formulario
   */
  (0, _react.useEffect)(() => {
    if (validateForm && prevSubmitTries !== submitTries && submitTries > 0) {
      if (datos.email == '') {
        datos.email = 'no.aplica@noaplica.com';
      }
      envioFormulario(datos);
    }
  }, [validateForm, prevSubmitTries, submitTries]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "AtencionModalForm",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "modal_wrapper-span",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
        text: tabOption === _index.TAB_OPTIONS.LLAMADA ? TextoSubTitle.llamada : TextoSubTitle.visita,
        align: _gerenciatdUnifiedcomponents3.ALIGN.CENTER,
        size: _gerenciatdUnifiedcomponents3.SIZE.CAPTION1,
        color: _gerenciatdUnifiedcomponents3.COLOR.GREY_5,
        fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.REGULAR,
        kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.SPAN,
        segment: _gerenciatdUnifiedcomponents3.SEGMENT.EMP,
        display: _gerenciatdUnifiedcomponents3.DISPLAY.BLOCK
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "modal_formInputs",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: visitaDobleColumn && tabOption === _index.TAB_OPTIONS.VISITA ? 'wrapper_input-solicita' : '',
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton.default, {
            id: "nombre",
            name: "nombre",
            typeField: "text",
            theme: "formBox",
            onChange: handleInputChange,
            placeHolder: "Persona de contacto",
            defaultValue: datosUsuario && datosUsuario.nombre || '',
            segment: "emp",
            taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
              componentContent: 'input-nombre'
            }),
            toggleLabel: true,
            required: true,
            formSkeletonProps: formSkeletonProps
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton.default, {
            id: "telefono",
            name: "telefono",
            typeField: "tel",
            theme: "formBox",
            onChange: handleInputChange,
            placeHolder: "Tel\xE9fono de contacto",
            defaultValue: datosUsuario && datosUsuario.telefono || '',
            segment: "emp",
            taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
              componentContent: 'input-telefono'
            }),
            validators: [validatorList.ANY_PHONE],
            required: true,
            toggleLabel: true,
            formSkeletonProps: formSkeletonProps
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: visitaDobleColumn && tabOption === _index.TAB_OPTIONS.VISITA ? 'wrapper_input-solicita' : '',
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton.default, {
            id: "cif",
            name: "cif",
            typeField: "text",
            theme: "formBox",
            onChange: handleInputChange,
            placeHolder: config.allowNIF ? 'CIF/NIF de empresa' : 'CIF de empresa',
            defaultValue: datosUsuario && datosUsuario.docNumber || '',
            segment: "emp",
            validators: [validatorList.DOC_NUMBER],
            allowDocTypes: config.allowNIF ? [IDENTIFICATION_DOCUMENT_TYPES.CIF, IDENTIFICATION_DOCUMENT_TYPES.DNI, datosUsuario && datosUsuario.docTypeText || ''] : [IDENTIFICATION_DOCUMENT_TYPES.CIF, datosUsuario && datosUsuario.docTypeText || ''],
            taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
              componentContent: 'input-cif'
            }),
            required: true,
            toggleLabel: true,
            formSkeletonProps: formSkeletonProps
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton2.default, {
            title: "Provincia",
            name: "provincia",
            options: _provincias.default,
            onChange: handleSelectChangeProv,
            placeholder: "Provincia",
            required: true,
            width: "full",
            formSkeletonProps: formSkeletonProps,
            taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
              componentContent: 'select-provincia'
            }),
            hideTitle: true,
            className: "padding-right-10",
            segment: "empresas"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: visitaDobleColumn && tabOption === _index.TAB_OPTIONS.VISITA ? 'wrapper_input-solicita' : '',
          children: [config.email && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton.default, {
            id: "email",
            name: "email",
            typeField: "text",
            theme: "formBox",
            onChange: handleInputChange,
            placeHolder: "Correo electr\xF3nico (opcional)",
            defaultValue: datosUsuario && datosUsuario.email || '',
            segment: "emp",
            validators: [validatorList.EMAIL],
            taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
              componentContent: 'input-email'
            }),
            toggleLabel: true,
            formSkeletonProps: formSkeletonProps
          }), config.empleados && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton2.default, {
            title: "Numero empleados",
            name: "numeroEmpleados",
            options: _functionsUtils.EMPLEADOS,
            onChange: handleSelectChangeEmpleados,
            placeholder: "Numero empleados",
            required: true,
            width: "full",
            formSkeletonProps: formSkeletonProps,
            taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
              componentContent: 'select-numeroEmpleados'
            }),
            hideTitle: true,
            className: "padding-right-10",
            segment: "empresas"
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "modal_wrapper-button",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: tabOption
          }),
          borderRadius: _gerenciatdUnifiedcomponents2.BORDER_RADIUS.SM,
          color: _gerenciatdUnifiedcomponents2.BUTTON_COLOR.BLUE,
          size: buttonPropsSize,
          labelSize: _gerenciatdUnifiedcomponents2.LABEL_SIZE.REGULAR,
          buttonType: "submit",
          disable: !iframeReady,
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
            text: tabOption === _index.TAB_OPTIONS.LLAMADA ? 'Te llamamos gratis' : 'Solicitar visita',
            align: _gerenciatdUnifiedcomponents3.ALIGN.LEFT,
            size: _gerenciatdUnifiedcomponents3.SIZE.CAPTION1,
            color: _gerenciatdUnifiedcomponents3.COLOR.WHITE,
            fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.REGULAR,
            kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.SPAN,
            segment: _gerenciatdUnifiedcomponents3.SEGMENT.EMP,
            display: _gerenciatdUnifiedcomponents3.DISPLAY.INLINE
          }),
          segment: _gerenciatdUnifiedcomponents3.SEGMENT.EMP
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "modal_wrapper-horario",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
          text: "Horario de contacto: L-V de 9 a 18 h",
          align: _gerenciatdUnifiedcomponents3.ALIGN.CENTER,
          size: _gerenciatdUnifiedcomponents3.SIZE.CAPTION1,
          color: _gerenciatdUnifiedcomponents3.COLOR.GREY_9,
          fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.REGULAR,
          kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.SPAN,
          segment: _gerenciatdUnifiedcomponents3.SEGMENT.EMP,
          display: _gerenciatdUnifiedcomponents3.DISPLAY.BLOCK
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "modal_wrapper-legal",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_gerenciatdUnifiedcomponents.default, {
          onClick: () => _togglePrivacyPolicy(false),
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: 'togglePrivacity'
          }),
          className: "privacityFaq noButton",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
            text: "Consulta aqu\xED la informaci\xF3n sobre privacidad ",
            align: _gerenciatdUnifiedcomponents3.ALIGN.CENTER,
            size: _gerenciatdUnifiedcomponents3.SIZE.CAPTION1,
            color: _gerenciatdUnifiedcomponents3.COLOR.BLUE,
            fontType: _gerenciatdUnifiedcomponents3.FONT_TYPE.REGULAR,
            kind: _gerenciatdUnifiedcomponents3.KIND_TEXT.SPAN,
            segment: _gerenciatdUnifiedcomponents3.SEGMENT.EMP,
            display: _gerenciatdUnifiedcomponents3.DISPLAY.SPAN,
            className: "privacityFaq--span"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, {
            id: PrivacyPolicy ? 'CheuronUp' : 'CheuronDown',
            kind: "M",
            size: _gerenciatdUnifiedcomponents3.SIZE.CAPTION1,
            segment: "emp",
            color: _gerenciatdUnifiedcomponents3.COLOR.BLUE
          })]
        })
      }), PrivacyPolicy && (0, _functionsUtils.printPrivacyPolicy)()]
    })]
  });
};
AtencionFormulario.propTypes = {
  Modal: _propTypes.default.func.isRequired,
  taggingInfo: _propTypes.default.arrayOf([_propTypes.default.string]).isRequired,
  tipoTes: _propTypes.default.oneOf([_functionsUtils.TIPOS_ENCAMINAMIENTO]).isRequired,
  destino: _propTypes.default.oneOf([_functionsUtils.DESTINO]).isRequired,
  tes: _propTypes.default.oneOf([_functionsUtils.TESVALUES]).isRequired,
  visitaDobleColumn: _propTypes.default.bool
};
AtencionFormulario.defaultProps = {
  tipoTes: _functionsUtils.TIPOS_ENCAMINAMIENTO.SVC_C,
  destino: _functionsUtils.DESTINO.GEVICO,
  tes: _functionsUtils.TESVALUES.SI
};
var _default = AtencionFormulario;
exports.default = _default;

//# sourceMappingURL=index.js.map